<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-16 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-16 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>项目编号：</span>
        <span>{{ item.purchaseDemandCode }}</span>
      </van-row>
      <van-row>
        <span>物料编号：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row>
        <span>供货品类：</span>
        <span>{{ item.catgName }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row>
        <span>采购组织：</span>
        <span>{{ item.purorgName }}</span>
      </van-row>
      <van-row>
        <span>供应商编号：</span>
        <span>{{ item.suppId }}</span>
      </van-row>
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>定价方式：</span>
        <span>{{ item.priceMethodDict | dictFilter(priceMethodDictOptions) }}</span>
      </van-row>
      <van-row>
        <span>采购组长：</span>
        <span>{{ item.purgrpLeaderName }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'MaterialDetails',
  data() {
    return {}
  },
  props: {
    detailsList: {
      type: Array,
      required: true
    }
  },
  computed: {
    priceMethodDictOptions() {
      return this.$store.getters.dicts.pricing_method
    }
  },
  methods: {}
}
</script>
